import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import PublicRoutes from "./PublicRoutes";
import { isAuth } from "../helpers/cookies.js";
import CustomerPortalPage from '../pages/customer_portal/layout/CustomerPortalPage.jsx'
import AdminPortalPage from "../pages/admin_portal/layout/AdminPortalPage.jsx";
import { ADMIN_PORTAL_ACCESS } from "../helpers/constants.js";
import PageForbidden from "../pages/public/PageForbidden.jsx";
import ProofPage from "../pages/customer_portal/ProofPage.jsx";
import ProofStatusPage from "../components/proof/ProofStatus.jsx";
import Footer from "../components/Footer.jsx";
import { useLocation } from "react-router-dom";
const index = () => {
  return (
      <Router future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}>
        <InnerRoutes />
      </Router>
    );
  };

  const InnerRoutes = () => {
    const location = useLocation();

    const hideFooterRoutes = ["/proof-status", "/viewproof"];
    const shouldHideFooter = hideFooterRoutes.some((path) =>
      location.pathname.startsWith(path)
    );

  return (
    <>       
        <Routes>
          <Route path="/proof-status" element={<ProofStatusPage />} />
            <Route path="/viewproof/*" element={<ProofPage />} />
          {
            ADMIN_PORTAL_ACCESS.includes(isAuth().role) && window.location.pathname.includes('/admin') ? (
              <Route path="/admin/*" element={<AdminPortalPage/>} />
            ) : isAuth() ? (
              <Route path="/*" element={<CustomerPortalPage/>} />
            ) : (
              <Route path="/*" element={<PublicRoutes />} />
            )
          }
          <Route path="/page-403" element={<PageForbidden/>} />
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
        {!shouldHideFooter && <Footer />}
    </>
  );
};

export default index;
